var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{on:{"click":function($event){return _vm.assignCode()}}},[_vm._v("Verify")])
}
var staticRenderFns = []

export { render, staticRenderFns }